export default "__VITE_ASSET__iEch98bf__"